import React, { Component } from 'react';
import './VerifyPhone.css'
import authService from '../../../services/auth.service';

declare var $;
declare var FB;
class VerifyPhone extends Component {

 constructor(props) {
   super(props)
   this.state = {
     countryCode: '',
     phone: '',
     smsSended: false,
     error: '',
     code: ''
   }
   this.setCountryCode = this.setCountryCode.bind(this);
   this.setPhone = this.setPhone.bind(this);
   this.sendSMS = this.sendSMS.bind(this);
   this.setCode = this.setCode.bind(this);
   this.verifyCode = this.verifyCode.bind(this);
   this.changePhone = this.changePhone.bind(this);
   this.setCurrentCountryCode = this.setCurrentCountryCode.bind(this)
 }

 componentDidMount() {

   this.setCurrentCountryCode()
 }


 async sendSMS() {
   let error;
   this.setState({
     smsSended: false
   })
   let response = await authService.sendSMS(this.state.phone, this.state.countryCode)
   if(response.id) {
      this.setState({
        smsSended: true
      })
     error = ''
   } else {
       error =  response.message
   }
   this.setState({
     error
   })
 }

 setCountryCode(event) {
  this.setState({
    countryCode: event.target.value
  })
 }

setPhone(event) {
  this.setState({
    phone: event.target.value
  })
 }

 setCode(event) {
   this.setState({
     code: event.target.value
   })
 }

 async verifyCode() {
   let response = await authService.verifyCode(this.state.code, this.state.countryCode, this.state.phone)
   if(response.status === 'SUCCESSFUL') {
       this.props.verified(this.state.phone);
   } else {
     this.setState({
       error: response.message
     })
   }
 }

 changePhone() {
   this.setState({
     smsSended: false,
     error: ''
   })
 }

 setCurrentCountryCode() {
   let countryCode;
   if(localStorage.getItem('country') === 'co') {
     countryCode = '+57';
   } else {
     countryCode = '+52';
   }
   this.setState({
     countryCode,
   })
 }


  render() {
    return (
        <div>
      { !this.state.smsSended &&
        <div id="verifyPhone" className="container animated fadeIn" >
            <h4>Ingresa con tu número celular</h4>
          <div className="row">

              <select className="country-code browser-default" value={this.state.countryCode} name="countryCode" required onChange={this.setCountryCode}>
                  <option value="+57">+57 (Colombia)</option>
                  <option value="+52">+52 (Mexico)</option>
                  <option value="+55">+55 (Brazil)</option>
                  <option value="+54">+54 (Brazil)</option>
                  <option value="+1">+1 (Estados Unidos)</option>
                  <option value="+56">+56(Chile)</option>
                  <option value="+33">+33 (Francia)</option>
              </select>



              <input type="number" name="phone"  value={this.state.phone} onChange={this.setPhone} placeholder="Número de celular"/ >

            </div>

              { this.state.error != '' && <p className="error animated shake">{this.state.error}</p> }
              <a  className="btn btn-orange" onClick={this.sendSMS}>Continuar</a>
        </div>
      }
      { this.state.smsSended &&
        <div id="verifyPhone">
          <h4 className="text-center">Te hemos enviado un codigo de verificación</h4>
          <div className="row">
            <div className="content text-center col-md-6 col-md-push-3 animated flipInX">
              <input type="number" name="code" placeholder="Codigo"  value={this.state.code}  onChange={this.setCode} />
            </div>
          </div>
            <div className="text-center row">
              <div className="col-md-4 col-md-push-4">
                { this.state.error !== '' && <p className="error animated shake">{this.state.error}</p> }
                <a className="btn verify animated flipInX"  onClick={this.verifyCode}  data-loading-text="<i class='spinner'></i> Verificando...">Verificar</a>
                  <p className="change">  <span onClick={this.changePhone}>  Cambiar número celular |</span> <span onClick={this.sendSMS}>  Reenviar SMS </span> </p>
              </div>
            </div>
        </div>
      }
      </div>
    );
  }
}


export default VerifyPhone;



// WEBPACK FOOTER //
// ./src/components/auth/verify-phone/VerifyPhone.js